function buildShopProductElement($autocompleteContainer, product) {
    let $li = $(
        '<li>' +
            '<a>' +
                '<img class="product-image" src="" />' +
                '<span>' +
                    '<span class="product-name"></span>' +
                    '<span class="product-brand"></span>' +
                    '<span class="product-price"></span>' +
                '</span>' +
            '</a>' +
        '</li>'
    );

    if (product.media.length > 0) {
        $li.find(".product-image").attr("src", product.media[0].url);
    }

    $li.find("a").attr("href", product.websiteUrl);
    $li.find(".product-name").text(product.name.toUpperCase());
    $li.find(".product-brand").text(product.brand.name.toUpperCase());
    $li.find(".product-price").text(
        0 === Math.round(product.finalPrice)
            ? $autocompleteContainer.attr('data-price-label')
            : Math.round(product.finalPrice).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' €'
    );

    return $li;
}

function buildBrandElement(element) {
    let $li = $(
        '<li>' +
            '<a><span class="brand-name"></span></a>' +
            '<span class="product-total-count"></span>' +
        '</li>'
    );

    $li.find("a").attr("href", element.shopProductBrand.productBrandUrl);
    $li.find(".brand-name").text(element.shopProductBrand.productBrand.name);
    $li.find(".product-total-count").text("(" + element.total_count + ")");

    return $li;
}

function getProductAutocompleteList($element)
{
    if ($element.find('.product-search-form-results').length === 0) {
        $productElement = $(
            '<div class="product-search-form-results">' +
                '<span>' + $element.attr('data-products-label') + '</span>' +
                '<ul></ul>' +
            '</div>'
        );

        $productElement.prependTo($element);
    }

    return $element.find('.product-search-form-results');
}

function initHeaderProductSearch() {
    if (null === document.querySelector('.maier-header-quick-navigation form .product-search-form-autocomplete')) {
        return;
    }

    let $autocompleteContainer = $(".maier-header-quick-navigation form .product-search-form-autocomplete");
    let $productList = getProductAutocompleteList($autocompleteContainer);

    let Search = new window.Search(
        '.maier-header-quick-navigation form .product-search-form-autocomplete',
        '.maier-header-quick-navigation form',
        function(result, search) {
            $productList.find('ul').html('');

            result.autocomplete.products.forEach(function(product) {
                $productList.find('ul').append(buildShopProductElement($autocompleteContainer, product));
            });

            $autocompleteContainer.addClass("open");
        }
    );
}

function initHeaderMobileProductSearch() {
    if (null === document.querySelector('.maier-header-menu-mobile-search form .product-search-form-autocomplete')) {
        return;
    }

    let $autocompleteContainer = $(".maier-header-menu-mobile-search form .product-search-form-autocomplete");
    let $productList = getProductAutocompleteList($autocompleteContainer);

    let Search = new window.Search(
        '.maier-header-menu-mobile-search form .product-search-form-autocomplete',
        '.maier-header-menu-mobile-search form',
        function(result, search) {
            $productList.find('ul').html('');

            result.autocomplete.products.forEach(function(product) {
                $productList.find('ul').append(buildShopProductElement($autocompleteContainer, product));
            });

            $autocompleteContainer.addClass("open");
        }
    );
}


function setupProductSearch() {
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            initHeaderProductSearch();
            initHeaderMobileProductSearch();
        })
    })
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupProductSearch);
} else {
    setupProductSearch();
}